import BaseUpdateRequest from "../Shared/BaseUpdateRequest";
import OfferCancelledReason from "./OfferCancelledReason";

export default class CancelJobWorkerOfferRequest extends BaseUpdateRequest {
    jobWorkerOfferId = '';
    cancelReason: OfferCancelledReason;
 
}